import React from 'react';
import CartRCAProduct from './CartRCAProduct';

const CartProduct = (props)=>{
    const {product, removeCartItem, editOption, requestApiData} = props;

    const showProduct = (product) => {
        let result;
        switch(product.type) {
            case 'rca':
                result = 
                    <CartRCAProduct 
                        product={product} 
                        removeCartItem={removeCartItem}
                        editOption={editOption}
                        requestApiData={requestApiData}
                    /> ;
            break;
        }
        return result;
    }

    const html = showProduct(product);
    
    return (
        html
    );
}

export default CartProduct;